export const favorite = {
    title: 'My favorite',
    tab_menu: 'Menu',
    tab_order: 'Order',
    btn_order_now: 'Order now',
    thb: 'Baht',
    order_no: 'Ordre No',
    order_on: 'Order on',
    total: 'Total',
    status: 'Status',
    reorder: 'Re-Order',
}
